import { DashboardOutlined, UserSwitchOutlined, BankOutlined, UsergroupAddOutlined, DollarCircleOutlined, CreditCardOutlined, SafetyCertificateOutlined, SolutionOutlined, BookOutlined } from '@ant-design/icons';
const icons = {
    DashboardOutlined,
    UserSwitchOutlined,
    BankOutlined,
    UsergroupAddOutlined,
    DollarCircleOutlined,
    CreditCardOutlined,
    SafetyCertificateOutlined,
    SolutionOutlined,
    BookOutlined
};

const instituitionMenu = {
    items: [
        {
            id: 'group-dashboard',
            title: 'Dashboard',
            type: 'group',
            children: [
                {
                    id: 'dashboard',
                    title: 'Dashboard',
                    type: 'item',
                    url: '/institution/dashboard',
                    icon: icons.DashboardOutlined,
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'users',
            title: 'Users',
            type: 'group',
            children: [
                {
                    id: 'authozied-users',
                    title: 'Authorized Users',
                    type: 'item',
                    url: '/institution/authorized-users',
                    icon: icons.UserSwitchOutlined
                },
                {
                    id: 'beneficiary',
                    title: 'Beneficiary',
                    type: 'item',
                    url: '/institution/beneficiary',
                    icon: icons.UsergroupAddOutlined
                },
                {
                    id: 'education-request',
                    title: 'Education Request',
                    type: 'item',
                    url: '/institution/education-request',
                    icon: icons.BookOutlined
                }
            ]
        },
        {
            id: 'transactions',
            title: 'Transactions',
            type: 'group',
            children: [
                {
                    id: 'requests',
                    title: 'Requests',
                    type: 'item',
                    url: '/institution/requests',
                    icon: icons.SolutionOutlined
                }
            ]
        }
    ]
};

export default instituitionMenu;
